export default "__VITE_ASSET__DkqSf2iA__"